import { render } from "./officers.vue?vue&type=template&id=c22c18ec&scoped=true"
import script from "./officers.vue?vue&type=script&lang=js"
export * from "./officers.vue?vue&type=script&lang=js"

import "./officers.vue?vue&type=style&index=0&id=c22c18ec&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22c18ec"]])

export default __exports__